import NavRouter from "./utils/NavRouter";
import "./App.css";

function App() {
  return (
    <body>
      <NavRouter />
    </body>
  );
}

export default App;
